<template>
    <org-main @back="goBack">
        <template slot="nav">
            <div class="orgNav">
                <p>帮助</p>
            </div>
        </template>
        <template slot="main">
            <div class="orgMain">
<!--                <div class="searchWrap"></div>-->
                <div class="scrollArea">
                    <vue-scroll :ops="ops" ref="vs"  style="overflow-x: hidden">
                        <div class="content-wrapper" id="collapse-ele">
                            <el-collapse v-model="activeNames" @change="handleChange" accordion>
                                <el-collapse-item title="1. 如何修改手机号？" name="1" class="collapse-title">
                                    <div>首页-》设置-》帐号和密码设置-》手机 进行修改。</div>
                                </el-collapse-item>
                                <el-collapse-item title="2. 如何修改登录密码？" name="2" class="collapse-title">
                                    <div>首页-》设置-》帐号和密码设置-》密码 进行修改。</div>
                                </el-collapse-item>
                                <el-collapse-item title="3. 系统中存在未显示的资质？" name="3" class="collapse-title">
                                    <div>首页-》缺失资质-》上传缺失资质 等待审核。</div>
                                </el-collapse-item>
                                <el-collapse-item title="4. 培训结束后如何查询成绩？" name="4" class="collapse-title">
                                    <div>培训结束后需要中国足协进行成绩审核，审核通过以后会第一时间通过短信告知，请耐心等待。</div>
                                    <div>收到查询短信登录系统-》培训历程-》XXXX培训班-》历程查询获得成绩。</div>
                                </el-collapse-item>
                                <el-collapse-item title="5. 证件照片格式是什么？" name="5" class="collapse-title">
                                    <div>照片格式：</div>
                                    <div>
                                        <p>1)不能对着照片拍</p>
                                        <p>2)不能带水印</p>
                                        <p>3)裁剪必须把头发裁剪完整，不能只留一个大头</p>
                                        <p>4)方形照片需要返回进行二次裁剪</p>
                                        <p>5)不能自拍</p>
                                        <p>6)必须白底，最好是纯白底</p>
                                        <p>7)查看大图为清晰，不能模糊</p>
                                        <p>8)需要证件照不能为全身照</p>
                                    </div>
                                </el-collapse-item>
                                <el-collapse-item title="6. 为什么一直没有电子证书和执照？" name="6" class="collapse-title">
                                    <div>首页-》我的简历-》基本信息 审核详情，如果证件照片没有过，请查看帮助第五条</div>
                                </el-collapse-item>
                                <el-collapse-item title="7. 基本设置信息审核为什么一直没有动静？" name="7" class="collapse-title">
                                    <div>基本设置信息审核是阶段性的，每年的六月份和十二月份会进行信息审核。</div>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    </vue-scroll>
                </div>

            </div>
        </template>
    </org-main>
</template>

<script>
    import ops from '@/assets/js/vuescrollOption';

    export default {
        name: "expire_help",
        components: {
            "org-main": () => import("@/components/LayOut/Common/up-down"),
            "yioks-empty": () => import("@/components/Tips/Empty"),
            "yioks-loading": () => import("@/components/Loading/Loading"),
            "v-icon": () => import("vue-awesome/components/Icon")
        },
        data() {
          return {
              activeNames: ['1'],
              ops: {
                  scrollPanel:{
                      scrollingX: false,
                  },
                  rail: {
                      size: '8px',
                      background:  '#ffffff',
                      opacity:  0.2,
                      gutterOfSide: '5px',
                  },
                  bar: {
                      onlyShowBarOnScroll: true,
                      background:  '#ffffff',
                      opacity:  0.4,
                      keepShow: false,
                  },
              },
          }
        },
        methods: {
            goBack() {
                this.$router.push('/expireStudent/expire_index');
            },
            handleChange(val) {
                console.log(val);
            }
        },
    }
</script>

<style lang="stylus" scoped>
    @import "~@/assets/css/variable";
    @import "~@/assets/css/mixin";
    .orgNav, .orgMain {
        flex: 1 1 auto;
        height: 100%;
    }
    .orgNav {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 12px 0 0;
        font-size: $font_size_big;
        .addOrg {
            width: 125px;
            height: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: $color_suc;
            cursor: pointer;
        }
    }

    .orgMain {
        width: 100%;
        padding: 25px 25px 0;
        background-color: $block_bg_color_base;
        .scrollArea {
            height: 560px;
            overflow-x: hidden;
            padding: 0 10px;
            .content-wrapper {
                /*padding 25px*/
                margin-right 30px
                .collapse-title {
                    text-indent 1em
                }
            }
        }
    }
</style>

<style >
    #collapse-ele .el-collapse-item__header{
        color: #fff !important;
        background-color: rgba(0, 0, 0, 0) !important;
    }
    #collapse-ele .el-collapse-item__wrap {
        background-color: rgba(0, 0, 0, 0) !important;
    }
    #collapse-ele .el-collapse-item__content{
        color: #fff !important;
    }
</style>
